// UI libs bundled by esbuild, exposed as globals (window.X) that the Stimulus
// controllers consume. Replaces the importmap pins + the classic sweetalert2 script.
import IMask from "imask"
import TomSelect from "tom-select"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import Swal from "sweetalert2"

window.IMask = IMask
window.TomSelect = TomSelect
flatpickr.l10ns = flatpickr.l10ns || {}
flatpickr.l10ns.pt = Portuguese
window.flatpickr = flatpickr
window.Swal = Swal

// Declarative confirmations (data-turbo-confirm) use Swal instead of native confirm().
window.Turbo.config.forms.confirm = (mensagem) =>
  Swal.fire({
    title: "Confirmação",
    text: mensagem,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, confirmar",
    cancelButtonText: "Cancelar"
  }).then((r) => r.isConfirmed)
